import { Icon } from 'antd'

export default Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1009346_hgla7b5sjyc.js'
})


// WEBPACK FOOTER //
// ./src/icon/index.ts